(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('change', (event) => {
    if (!event.target.matches('[id^="Variant-"]')) return;
    const option = event.target.options[event.target.selectedIndex];
    const section = event.target.closest('.main-product');
    const price = section && section.querySelector('[data-product-price]');
    if (price && option.dataset.price) price.textContent = option.dataset.price;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const wrapper = document.querySelector('.reviews-slider-wrapper');
    if (!wrapper) return;

    const section  = wrapper.closest('.section-shell');
    const track    = section.querySelector('.reviews-slider-track');
    const viewport = section.querySelector('.reviews-slider-viewport');
    const btnPrev  = section.querySelector('.reviews-btn--prev');
    const btnNext  = section.querySelector('.reviews-btn--next');
    const dots     = section.querySelectorAll('.reviews-dot');
    const cards    = section.querySelectorAll('.review-card');

    if (!track || !cards.length) return;

    const colsMobile  = parseInt(track.dataset.colsMobile)  || 1;
    const colsTablet  = parseInt(track.dataset.colsTablet)  || 2;
    const colsDesktop = parseInt(track.dataset.colsDesktop) || 3;
    const gap         = parseInt(track.dataset.gap)         || 30;

    let current = 0;

    function visibleCount() {
      const vw = window.innerWidth;
      if (vw <= 600)  return colsMobile;
      if (vw <= 1024) return colsTablet;
      return colsDesktop;
    }

    function setCardWidths() {
      const cols = visibleCount();
      const totalGap = gap * (cols - 1);
      const cardW = (viewport.offsetWidth - totalGap) / cols;
      cards.forEach(c => {
        c.style.width    = cardW + 'px';
        c.style.minWidth = cardW + 'px';
      });
      track.style.gap = gap + 'px';
    }

    function maxIndex() {
      return Math.max(0, cards.length - visibleCount());
    }

    function goTo(index) {
      current = Math.max(0, Math.min(index, maxIndex()));
      setCardWidths();
      const cardWidth = cards[0].offsetWidth;
      const computedGap = parseFloat(getComputedStyle(track).gap) || 0;
      track.style.transform = `translateX(-${current * (cardWidth + computedGap)}px)`;
      dots.forEach((d, i) => d.classList.toggle('is-active', i === current));
      btnPrev.disabled = current === 0;
      btnNext.disabled = current >= maxIndex();
    }

    btnPrev.addEventListener('click', () => goTo(current - 1));
    btnNext.addEventListener('click', () => goTo(current + 1));
    dots.forEach(d => d.addEventListener('click', () => goTo(+d.dataset.index)));
    window.addEventListener('resize', () => goTo(Math.min(current, maxIndex())));
    goTo(0);
  })();

  } catch(e) { console.error(e); }
})();
})();
